/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    }
})

// show hide the buy now button
// if the user has scrolled 100px
window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

/**************************************** Form *************************************/

// move to second part of form
document.querySelector("#productFormNext").addEventListener("click", function (e) {
    e.preventDefault();
    this.closest('.productForm').classList.add("active");
});

// move to first part of form
document.querySelector("#productReturn").addEventListener("click", function (e) {
    e.preventDefault();
    this.parentElement.classList.remove("active");
});

document.querySelector(".productForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = new FormData(this);

    // Subscription
    if (document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productForm.active .productFormFrequency").getAttribute("selling_plan"))
    }

    this.querySelector('#productATC').classList.add("loading");

    // clear cart
    await fetch("/cart/clear.js");

    // add to cart
    await addProduct({
        id: `${formData.get('amount')}`,
        properties: {
            "Recipient email": `${formData.get('email')}`,
            "Recipient name": `${formData.get('name')}`,
            "Message": `${formData.get('note')}`,
            "__shopify_send_gift_card_to_recipient": true,
            "_added_at": Date.now() // When the line entered the cart, keeps the mini cart order stable
        }
    });

    // stop loading
    this.querySelector('#productATC').classList.remove("loading");

    // redirect to cart
    window.location.href = "/cart";
});